import React from 'react';
import PropTypes from 'prop-types';

const Radio = (props) => {
  const {
    name = '',
    value = '',
    selectedValue = '',
    label = null,
    labelClass = 'custom-control',
    inputClass = 'with-gap bg-primary-darken-1',
    invalidFeedback = false,
    onChange = () => {},
    disabled = false,
  } = props;

  return (
    <label className={labelClass}>
        <input
          type="radio"
          className={inputClass}
          onChange={onChange.bind(null, value)}
          checked={selectedValue === value}
          name={name}
          disabled={disabled}
        />
        <span>{label}</span>
        { invalidFeedback &&
          <div className="invalid-feedback">
            {invalidFeedback}
          </div>
        }
    </label>
  );
};

Radio.PropTypes = {
  name: PropTypes.string.required,
  value: PropTypes.string.required,
  label: PropTypes.string,
  selectedValue: PropTypes.string.required,
  onChange: PropTypes.func.required,
  disabled: PropTypes.bool,
};

export default Radio;



// WEBPACK FOOTER //
// ./src/Common/Radio.js